import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';
import { Subject, takeUntil } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';

@Component({
  selector: 'custom-clear-all-filter',
  templateUrl: './clear-all-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TranslateModule],
})
export class ClearAllFilterComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private shoppingFacade = inject(ShoppingFacade);

  private destroy$ = new Subject<void>();
  showClearAll$: Observable<boolean>;

  ngOnInit(): void {
    this.showClearAll$ = this.activatedRoute.queryParamMap.pipe(
      map(queryParamMap => {
        if (queryParamMap.get('filters')?.split('&')?.length > 1) {
          return true;
        } else {
          return false;
        }
      }),
      takeUntil(this.destroy$)
    );
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clearFilter() {
    this.shoppingFacade.loadFilterOnRouteChange();
    this.router.navigate([], {
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
      queryParams: { filters: undefined, page: 1 },
    });
  }
}
